import { openPathNames } from '../consts';

export default function isOpenPathname(pathname: string) {
	return openPathNames.some(pathnameCheck =>
		pathnameCheck instanceof RegExp
			? pathnameCheck.exec(pathname)
			: pathnameCheck === pathname,
	);
}
